"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
var react_1 = __importStar(require("react"));
var validations_1 = require("../../lib/functions/validations");
var styles = __importStar(require("./Popup.module.css"));
var rules = {
    email: validations_1.email,
    password: validations_1.mandatory
};
var Popup = (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeCredentials = function (evt) {
            var _a;
            var _b = evt.target, name = _b.name, value = _b.value;
            var newState = (_a = {}, _a[name] = value, _a);
            _this.setState(newState);
        };
        _this.onClosePopup = function () {
            _this.setState({
                email: "",
                password: ""
            });
            _this.props.onClose();
        };
        _this.onSignIn = function () { return __awaiter(_this, void 0, void 0, function () {
            var credentials, error_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = this.state;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.model.edularCoreSignIn(credentials)];
                    case 2:
                        _a.sent();
                        this.setState({
                            response: {
                                success: true,
                                message: ""
                            }
                        });
                        this.props.onClose();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log("error-->>", error_1);
                        message = void 0;
                        if (["invalid_password", "student_not_found"].includes(error_1["code"])) {
                            message = "Incorrect email address or password.";
                        }
                        if (error_1["code"] === "access_disabled") {
                            message =
                                "Your access was temporarily disabled. Please, contact your school administrator to reinstate your access.";
                        }
                        if (error_1["code"] === "invalid_user_type") {
                            message = "User with role different to staff are not allowed to Sign In.";
                        }
                        this.setState({
                            response: {
                                success: false,
                                message: message
                            }
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.onModel = _this.onModel.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        _this.state = {
            email: "",
            password: "",
            slug: "hhs",
            response: {
                success: true,
                message: ""
            }
        };
        return _this;
    }
    Popup.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Popup.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Popup.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Popup.prototype.render = function () {
        var _a = this.props, classNameWrap = _a.classNameWrap, className = _a.className, children = _a.children;
        var _b = this, onClosePopup = _b.onClosePopup, onChangeCredentials = _b.onChangeCredentials, onSignIn = _b.onSignIn;
        var response = this.state.response;
        return (react_1.default.createElement("div", { "aria-labelledby": "loginModalLabel", id: "loginModal", role: "dialog", className: styles.basket },
            react_1.default.createElement("div", { className: "modal-dialog ".concat(styles.dialog), role: "document" },
                react_1.default.createElement("div", { className: "modal-content" },
                    react_1.default.createElement("div", { className: "modal-header" },
                        react_1.default.createElement("h5", { className: "modal-title" }, "Please sign in"),
                        react_1.default.createElement("button", { "aria-label": "Close", className: "close", "data-dismiss": "modal", type: "button", onClick: onClosePopup },
                            react_1.default.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                    react_1.default.createElement("div", { className: "modal-body" },
                        !response.success && (react_1.default.createElement("div", { className: "alert alert-danger", id: "auth-alert", role: "alert" }, response.message)),
                        react_1.default.createElement("form", { className: "form-signin" },
                            react_1.default.createElement("div", { className: "input-group mb-3" },
                                react_1.default.createElement("label", { className: "sr-only", htmlFor: "inputEmail" }, "Email address"),
                                react_1.default.createElement("input", { className: "form-control", id: "inputEmail", name: "email", placeholder: "Email address", required: true, type: "email", onChange: onChangeCredentials })),
                            react_1.default.createElement("div", { className: "input-group" },
                                react_1.default.createElement("label", { className: "sr-only", htmlFor: "inputPassword" }, "Password"),
                                react_1.default.createElement("input", { className: "form-control", name: "password", id: "inputPassword", placeholder: "Password", required: true, type: "password", onChange: onChangeCredentials })))),
                    react_1.default.createElement("div", { className: "modal-footer" },
                        react_1.default.createElement("button", { className: "btn btn-secondary", "data-dismiss": "modal", id: "btn-close-signin", type: "button", onClick: onClosePopup }, "Close"),
                        react_1.default.createElement("button", { className: "btn btn-primary", id: "btn-signin", type: "button", onClick: onSignIn }, "Sign In"))))));
    };
    return Popup;
}(react_1.Component));
exports.Popup = Popup;
//# sourceMappingURL=data:application/json;base64,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